import {Component, OnInit, Injector, ViewChild} from '@angular/core';

import { Meta } from '../../../_models/meta';
import {EstudioService} from '../estudio.service';
import {UnidadEtapasService} from '../unidad-etapas/_services/unidad-etapas.service';
import { MetaFormComponent } from '../meta-form/meta-form.component';

@Component({
  selector: 'app-meta-form-injector',
  standalone: false,
  templateUrl: './meta-form-injector.component.html',
  styleUrls: ['./meta-form-injector.component.scss']
})
export class MetaFormInjectorComponent implements OnInit {

  _meta: Meta;
  tiposMeta: any[];
  cursosOpt: any[];
  areas: any[];
  profesores: any[];
  ambitos: any[];
  tags: any[];
  contexto: string;
  metaUnidadID: number | string;
  activeTab = 0;
  guardando = false;
  unidadId;

  @ViewChild(MetaFormComponent)
  private metaFormComponent: MetaFormComponent;

  constructor(private injector: Injector,
              private estudioService: EstudioService,
              private unidadEtapasService: UnidadEtapasService) {
  }

  ngOnInit() {
    this._meta = this.injector.get('meta', {});
    this.tiposMeta = this.injector.get('categorias', []);
    this.cursosOpt = this.injector.get('cursos', []);
    this.areas = this.injector.get('areas', []);
    this.profesores = this.injector.get('profesores', []);
    this.ambitos = this.injector.get('ambitos', []);
    this.tags = this.injector.get('tags', []);
    this.contexto = this.injector.get('contexto', 'meta_form');
    this.metaUnidadID = this.injector.get('metaUnidadID', 0);
    this.activeTab = this.injector.get('tabActiva', 0);
    this.unidadId = this.injector.get('unidadId', undefined);
  }

  actualizar(resp: any) {
    this.estudioService.actualizarElemento('meta', resp);
    this.unidadEtapasService.actualizarLista('metas', resp);
  }

  cancelar() {
    this.metaFormComponent.cancelar();
  }

  guardar() {
    this.metaFormComponent.guardar();
  }

  guardandoActualizar(event: boolean) {
    this.guardando = event;
  }
}
